import React from 'react';
import { Redirect, Link } from 'react-router-dom';

import {ReactComponent as XBUTTONPLAYERLIST} from '../xButtonListe.svg';

export default class PlayerListe extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      error : '',
    };

  }


  componentDidMount(){
    console.log(this.props.items);
  }


  render () {

    let namedItems = this.props.items.map((choosenItem)=>{
      return (
        <React.Fragment key={choosenItem.index}>
          <hr style={{width:"80%", marginLeft:"auto", marginRight:"auto"}}/>
          <h5 style={{fontWeight: "bold"}}>
            <li style={{marginLeft:"10%"}}>{choosenItem.item.name}</li>
          </h5>
        </React.Fragment>
      );
    })

    return (
      <React.Fragment>
      <div id="" style={{backgroundColor:"#00000090", position:"fixed", top:"0", left:"0", width: "100%", height:"100%", zIndex:"10"}} >
        <div style={{position:"absolute", backgroundColor:"#FFF", top:"50%", left:"50%", width:"80%", maxWidth:"500px", height:"60%", margin:"0", transform:"translateY(-50%) translateX(-50%)", padding:"20px", display: "flex", flexDirection:"column", fontWeight: "bolder",color:"#0061ae"}}>
          <div style={{marginBottom:"20px"}}>
            <img src="/assets/branding/maxi_md_blue.png" alt="" style={{
              width:"60%",
              minWidth:"110px",
              maxWidth:"200px",
              height: "auto",
              objectFit: "cover"
            }}/>
            <XBUTTONPLAYERLIST id="xButtonPlayerList" style={{position:"absolute", width:"40px", height:"40px", top:"20px", right:"20px"}} onClick={this.props.closeList }/>
          </div>
          <div style={{marginBottom:"20px"}}>
            <h2 style={{fontWeight: "bolder"}}>VOTRE LISTE D'ÉPICERIE</h2>
          </div>
          <div id="playerListe" style={{overflowY:"scroll",overflowX:"hidden", height:"100%", textAlign:"left"}}>
            {namedItems}
            <hr style={{width:"80%", marginLeft:"auto", marginRight:"auto"}}/>
          </div>
        </div>
      </div>
      </React.Fragment>
    );
  }
}
